import {
  addToCartApi,
  deleteFromCartApi,
  getCartProductsApi,
} from "src/services/CartApi";
import {
  addToCart,
  decreaseQuantity,
  deleteFromCart,
  increaseQuantity,
} from "./cart-slice";

export const addToCartAsync =
  (product, quantity, variantId, accessToken, slotId) => async (dispatch) => {
    dispatch(addToCart(product));
    if (!accessToken) return;
    try {
      const response = await addToCartApi(product, quantity, variantId, slotId);
      console.log(response);
    } catch (error) {
      console.error("Cart sync failed:", error);
    }
  };

export const increaseQuantityAsync =
  (product, quantity, variantId, accessToken, slotId) => async (dispatch) => {
    dispatch(increaseQuantity(product));
    if (!accessToken) return;
    try {
      const response = await addToCartApi(product, quantity + 1, variantId, slotId);
      console.log(response);
    } catch (error) {
      console.error("Cart sync failed:", error);
    }
  };

export const decreaseQuantityAsync =
  (product, quantity, variantId, accessToken, slotId) => async (dispatch) => {
    dispatch(decreaseQuantity(product));
    if (!accessToken) return;
    try {
      await addToCartApi(product, quantity - 1, variantId, slotId);
    } catch (error) {
      console.error("Cart sync failed:", error);
    }
  };

export const asyncDeleteCartItem =
  (item, cartItemId, accessToken) => async (dispatch) => {
    dispatch(deleteFromCart(cartItemId));
    if (!accessToken) return;
    try {
      const serverCart = await getCartProductsApi();
      for (let i = 0; i < serverCart.length; i++) {
        if (serverCart[i].productId === item.ID) {
          if (item.variantId) {
            if (item.variantId === serverCart[i].variantId) {
              await deleteFromCartApi(serverCart[i].ID);
              return;
            }
          }
          if (item.slotId) {
            if (item.slotId === serverCart[i].slotId) {
              await deleteFromCartApi(serverCart[i].ID);
              return;
            }
          }
          await deleteFromCartApi(serverCart[i].ID);
          return;
        }
      }
    } catch (error) {
      console.error("Cart sync failed:", error);
    }
  };
